module.exports = __webpack_public_path__ + "static/media/sunrise-logo-footer.c8efd11d.svg";